import React from "react";
import "../styles/AdvisoryProcessFlow.css";
import { HiOutlineClipboardList } from "react-icons/hi";
import { GiRoad } from "react-icons/gi";
import { MdOutlineSupportAgent, MdSpatialTracking } from "react-icons/md";

const steps = [
  {
    id: "01",
    title: "Initial Consultation & Needs Assessment",
    description:
      "Understand your vision, challenges, and business goals. Analyze the specific needs of your startup.",
    icon: <HiOutlineClipboardList />,
  },
  {
    id: "02",
    title: "Strategic Roadmap Development",
    description:
      "Craft a clear plan for business setup, market penetration, and growth. Identify key milestones and metrics for success.",
    icon: <GiRoad />,
  },
  {
    id: "03",
    title: "Execution & Operational Support",
    description:
      "Implement the strategies with hands-on support. Optimize resources for efficient scaling.",
    icon: <MdOutlineSupportAgent />,
  },
  {
    id: "04",
    title: "Continuous Monitoring & Adjustments",
    description:
      "Regularly track performance against KPIs. Adapt the strategy as your startup grows and evolves.",
    icon: <MdSpatialTracking />,
  },
];

export default function AdvisoryProcess() {
  return (
    <section className="process-section">
      <h2 className="process-heading">Our Advisory Process</h2>
      <div className="process-steps">
        {steps.map((step, index) => (
          <div className="step-card" key={index}>
            <div className="step-icon-wrapper">
              <div className="step-icons">
                <div className="step-icon">{step.icon}</div>
              </div>
              <span className="step-number">{step.id}</span>
            </div>
            <h3 className="step-title">{step.title}</h3>
            <p className="step-desc">{step.description}</p>
            {index < steps.length - 1 && <div className="arrow" />}
          </div>
        ))}
      </div>
    </section>
  );
}
